var render, staticRenderFns
import script from "./LoginWithGoogle.vue?vue&type=script&lang=js"
export * from "./LoginWithGoogle.vue?vue&type=script&lang=js"
import style0 from "./LoginWithGoogle.vue?vue&type=style&index=0&id=a81fe246&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports